/* eslint-disable react/no-unescaped-entities */

export default function ProjectAboutSection() {
	return (
		<div className="fugu-gallery-data4">
			<h2>About the project:</h2>
			<p>
				There are many variations of passages of Lorem Ipsum available, but the majority have suf alteration in
				some form, by injected humour, or randomised words which dont look even slightly believable. If a you
				are going to use a passage of Lorem Ipsum, you need to bee ther anything embarrassing.
			</p>
		</div>
	);
}
